import { ServicesNames } from './ServicesNames';

export const Selector = {

    selectName: (service: string, index: number) => {

        let myService;

        switch (service) {
            case "services":
                myService = ServicesNames.services[index][0];
                console.log('selector ', myService)
                break;
            case "mifid":
                myService = ServicesNames.mifid[index][0];
                break;
            case "Market Connect Feed":
                myService = ServicesNames.feed[index][0];
                break;
            case "Finsite":
                myService = ServicesNames.finsite[index][0];
                break;
        }

        return myService;
    },

    selectRouter: (service: string, index: number) => {

        let myService;

        switch (service) {
            case "services":
                myService = ServicesNames.services[index][1];
                break;
            case "mifid":
                myService = ServicesNames.mifid[index][1];
                break;
            case "Market Connect Feed":
                myService = ServicesNames.feed[index][1];
                break;
            case "Finsite":
                myService = ServicesNames.finsite[index][1];
                break;
        }

        return myService;
    }
};